import _ from "lodash";

import { connect } from "react-redux";
import Grafiken from "./Grafiken";
import { setYValueAction, setYComponentAction,
	findAutoYRange, setXModeAction, setYModeAction,
	setXRangeAction, setYRangeAction, Y_MODE_AUTO }
	from "../model/Diagramme";
import { compressorIsInstalled, compressorNameOrNumber }
	from "../model/Kompressor";

import { getBarParamsStateChanges } from "./AnalyseTools";
import { chartsSetDataSourceAction, CHARTS_DATA_SOURCE_LIVE_STANDARD } from "../model/Diagramme";
import {
	requestStatePending,
	requestStateSucceeded,
	requestStateFailed,
} from "../model/HeDataLogs"

const makeYComponent = (index, make_label) => ({
	index: index,
	makeLabel: make_label
});

let lastYComponents = [];
let lastAvailableYComponents = [];

const makeYComponents = compressors => {
	/*
	 * erst mal schauen was es jetzt gibt
	 */
	let now = [-1];
	compressors.forEach((compressor, i) => {
		if (compressorIsInstalled(compressor)) {
			now.push(i);
		}
	});
	if (_.isEqual(now, lastAvailableYComponents)) {
		return lastYComponents;
	}

	/*
	 * und nur wenn wir echt müssen bauen wir neue Objekte!
	 */
	let choices = [
		makeYComponent(-1, intl => intl.formatMessage({ id: "Master control"}))
	];
	compressors.forEach((compressor, i) => {
		if (compressorIsInstalled(compressor)) {
			choices.push(makeYComponent(i, intl =>
				intl.formatMessage({ id: "Compressor" }) + " " +
				compressorNameOrNumber(compressor)));
		}
	});
	/*
	 * und noch puffern!
	 */
	lastAvailableYComponents = now;
	lastYComponents = choices;

	return lastYComponents;
};

const findYRange = (charts) => {
	let result = charts.y_range;
	if (!result) {
		result = findAutoYRange(charts.log_values, charts.x_range, charts.y_value);
	}
	return result;
};

const assertXRange = (charts) => {

	let result = charts.x_range;
	if (!result) {
		result = [0, 1];
	}
	return result;
};

const clipTo2Digits = (value) => {
	return (Math.round(value * 100)) / 100;
};

const moveRange = (range, percent) => {
	const diff = range[1] - range[0];
	const min = clipTo2Digits(range[0] + (diff * (percent / 100)));
	const max = clipTo2Digits(min + diff);
	return [min, max];
};

const getValidXRange = (state) => {
	if(state.charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
		return state.data_log.xrange
	}
	else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
		return state.he_data_log_files.xrange
	}
}

const getHeDataLogFilesRequestString = (state) => {
	if(state.charts.data_source_index === CHARTS_DATA_SOURCE_LIVE_STANDARD) {
		return "No text"
	}
	else { // CHARTS_DATA_SOURCE_SD_CARD_LOG_FILES
		if(
			(state.he_data_log_files.requestState === requestStatePending) ||
			(state.he_data_log_files.requestState === requestStateFailed)
		) {
			return state.he_data_log_files.requestState
		}
		else if(state.he_data_log_files.requestState === requestStateSucceeded) {
			// any log_values?
			if(state.charts.log_values.lengt === 0) {
				return "No Data"
			}
			// are all log_values === NaN
			let allNaN = true
			state.charts.log_values.forEach(item => {
				const value = _.get(item, state.charts.y_value.path)
				if(!isNaN(value)) {
					allNaN = false
				}
			})
			if(allNaN === true) {
				return "No Data"
			}
			else {
				return "No text"
			}
		}
		else {
			return "No text"
		}
	}
}

export default connect(state => ({
	state_changes: state.charts.state_changes,
	x_range: assertXRange(state.charts),
	x_range_valid: getValidXRange(state),
	x_mode: state.charts.x_mode,
	y_range: findYRange(state.charts),
	y_values: state.charts.y_values,
	y_value: state.charts.y_value,
	y_components: makeYComponents(state.ablauf.compressors),
	y_component_index: state.charts.y_component_index,
	show_compressor_state: state.charts.show_compressor_state,
	compressors: state.ablauf.compressors,
	bar_params: getBarParamsStateChanges(state.charts.state_changes.num_compressors),
	units: state.units,
	dataSourceOfCharts: state.charts.data_source_index,
	heDataLogFilesRequestState: getHeDataLogFilesRequestString(state)
}), dispatch => ({
	changeYValue: index => {
		dispatch(setYValueAction(index));
	},
	changeYComponent: index => {
		dispatch(setYComponentAction(index));
	},
	changeXMode: mode => {
		dispatch(setXModeAction(mode));
	},
	activateYAuto: () => {
		dispatch(setYModeAction(Y_MODE_AUTO));
	},
	moveX: (range, delta_prozent) => {
		dispatch(setXRangeAction(moveRange(range, delta_prozent)));
	},
	moveY: (range, delta_prozent) => {
		dispatch(setYRangeAction(moveRange(range, delta_prozent)));
	},
	setNewRangeY: (newRange) => {
		dispatch(setYRangeAction(newRange));
	},
	setNewRangeX: (newRange) => {
		dispatch(setXRangeAction(newRange));
	},
	setDataSourceOfCharts: (dataSourceIndex) => {
		dispatch(chartsSetDataSourceAction(dataSourceIndex))
	}
}))(Grafiken);
